import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import {
  TitleSection,
  NonInteractiveVisualizationWrapper,
} from '@mentimeter/question-modules-shared';
import { Box } from '@mentimeter/ragnar-ui/box';
import { RatingGridDataHandler } from './RatingGrid';

export function RatingPresentation() {
  const { useQuestion, InteractiveCanvasComponents } = usePresentationContext();

  const {
    question,
    question_description,
    question_styled,
    layout,
    title_meta,
    dimensions,
    range,
    sub_type,
    choices,
    grid,
    hide_results,
  } = useQuestion();

  const ConditionalWrapper =
    InteractiveCanvasComponents?.CanvasVisualizationArea
      ? InteractiveCanvasComponents?.CanvasVisualizationArea
      : NonInteractiveVisualizationWrapper;

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      data-testid="rating-container"
      justifyContent="center"
    >
      <TitleSection
        title={question}
        description={question_description}
        styledTitle={question_styled}
        label={title_meta}
        fontSizeOffset={layout?.font_size_offset}
        showTextSizeDropdown={true}
      />
      <ConditionalWrapper flex="1 1 auto" width="100%">
        <RatingGridDataHandler
          dimensions={dimensions}
          range={range}
          subType={sub_type}
          choices={choices}
          grid={grid}
          hideResults={hide_results}
        />
      </ConditionalWrapper>
    </Box>
  );
}
